


const Routes = {
  home: '/przymierzalnia',
  configuration: '/przymierzalnia/konfiguracja',
  view: '/przymierzalnia/widok',
  customer: '/przymierzalnia/dane-klienta',
  summary: '/przymierzalnia/podsumowanie',
  orderFinalized: '/przymierzalnia/zlozone-zamowienie',
}


export default Routes
